import { BASE_URL } from "../config";

export const popout = (url) => {
  window.open(BASE_URL + url, "_blank");
};
